import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import NavigationBar from './components/NavigationBar/NavBar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Events from './components/Events';
// import Services from './components/Services';
import PressKit from './components/PressKit';
import MediaKit from './components/MediaKit';
import Contact from './components/Contact';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorPage from './components/ErrorPage';
import RouteMetadata from './components/Seo';
import Admin from './components/Admin';

function AppContent() {
    const { pathname } = useLocation();
    const isAdmin = pathname === "/admin" || pathname.startsWith("/admin/");

    return (
      <ErrorBoundary>
        <RouteMetadata />
        {!isAdmin && <NavigationBar />}
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/presskit" element={<PressKit />} />
            <Route path="/media-kit" element={<MediaKit />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/403" element={<ErrorPage statusCode={403} />} />
            <Route path="/500" element={<ErrorPage statusCode={500} />} />
            <Route path="/503" element={<ErrorPage statusCode={503} />} />
            <Route path="*" element={<ErrorPage statusCode={404} />} />
        </Routes>
        {!isAdmin && <Footer/>}
      </ErrorBoundary>
    );
}

function App() {
    return <Router><AppContent /></Router>;
}

export default App;
